import {
  Component,
  Input,
  OnInit
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';

import { AddIncidentComponent } from '../../../components/diary/add-incident/add-incident.component';
import { ClientIncidentsService } from '../../../services/clientIncident/clientIncident.service';

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss']
})
export class IncidentsComponent implements OnInit {

  @Input()
  companyId: string;

  public incidents: any[] = [];

  public loading = false;

  constructor(
    private incidentsService: ClientIncidentsService,
    private dialog: MatDialog
  ) { }

  async ngOnInit() {

    await this.loadIncidents();
  }

  async loadIncidents() {

    if (!this.companyId) {
      return;
    }

    try {

      this.loading = true;

      const response =
        await this.incidentsService
          .getIncidentsByClient(
            this.companyId
          );

      this.incidents =
        response.data || [];

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No fue posible cargar las incidencias'
      });

    } finally {

      this.loading = false;
    }
  }

  async openAddIncidentModal() {

    const dialogRef = this.dialog.open(
      AddIncidentComponent,
      {
        width: '700px',
        disableClose: true,
        data: {
          clientId: this.companyId
        }
      }
    );

    dialogRef.afterClosed()
      .subscribe(async (result) => {

        if (result) {

          await this.loadIncidents();

          Swal.fire({
            icon: 'success',
            title: 'Incidencia registrada',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
  }

  async deleteIncident(
    incident: any
  ) {

    const confirm =
      await Swal.fire({

        title:
          '¿Eliminar incidencia?',

        text:
          'Esta acción no se puede deshacer',

        icon:
          'warning',

        showCancelButton:
          true,

        confirmButtonText:
          'Eliminar',

        cancelButtonText:
          'Cancelar'
      });

    if (!confirm.isConfirmed) {
      return;
    }

    try {

      await this.incidentsService
        .deleteIncident(
          incident._id
        );

      await this.loadIncidents();

      Swal.fire({
        icon: 'success',
        title: 'Incidencia eliminada'
      });

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No fue posible eliminar la incidencia'
      });
    }
  }

async editIncident(
  incident: any
) {

    const dialogRef = this.dialog.open(
      AddIncidentComponent,
      {
        width: '700px',
        disableClose: true,
        data: {

          clientId:
            this.companyId,

          incident:
            incident
        }
      }
    );

    dialogRef.afterClosed()
      .subscribe(async (result) => {

        if (result) {

          await this.loadIncidents();

          Swal.fire({
            icon: 'success',
            title: 'Incidencia actualizada',
            timer: 1500,
            showConfirmButton: false
          });
        }
      });
  }

}